import { useQuery } from '@tanstack/react-query'
import { queryKeys, QUERY_CONFIG } from '../../lib/react-query'
// The API module DIRECTLY, never the `services/api` barrel: the barrel pulls
// componentIcons.ts, whose module-scope webpack `require.context` throws under
// Jest and takes down any suite that touches this hook.
import { dashboardApi } from '../../services/api/dashboard.api'
import { useAuthStore } from '../../store/authStore'
import { useFeature } from '../../Utils/featureFlagEngine'
import type { DashboardResponse } from '../../app/modules/types/dashboard'

/**
 * The organization board's ONE request — `GET /dashboard/`.
 *
 * Every block on the board reads from this single payload. There is no
 * per-block endpoint and adding one would multiply the cost.
 *
 * Gated on the feature flag as well as the org: `FeatureGuard` hides UI but
 * does not stop a query, so an ungated hook still fires the request on a tenant
 * where the board is switched off.
 *
 * @param autoRefresh - Enable auto-refresh (default: true)
 */
export function useDashboard(autoRefresh = true) {
  const orgId = useAuthStore((state) => state.orgId)
  const { isEnabled } = useFeature()
  return useQuery<DashboardResponse>({
    queryKey: queryKeys.dashboard.data(orgId),
    queryFn: () => dashboardApi.getData(),
    staleTime: QUERY_CONFIG.DASHBOARD.staleTime,
    refetchInterval: autoRefresh ? QUERY_CONFIG.DASHBOARD.refetchInterval : false,
    enabled: !!orgId && isEnabled('dashboard'),
  })
}
